import assets from './assets';
import booking from './booking';
import availability from './availability';
import reservation from './reservation';
import product from './product';
import property from './property';
import securePayment from './secure_payment';
import account from './account';
import checkout from './checkout';
import vehicleLink from './vehicle_link';
import utility from './utility';
import resource from './resource';
import services from './services';
import entry from './entry';

export default {
  assets,
  availability,
  booking,
  reservation,
  securePayment,
  checkout,
  account,
  vehicleLink,
  product,
  utility,
  resource,
  property,
  services,
  entry,
};
